import { Box } from "@mui/material";
import { Outlet, useLocation } from "react-router";

const Files = () => {
  const location = useLocation();
  const currentTab = location.pathname.split("/").pop();

  if (currentTab === undefined) {
    return <></>;
  }

  return (
    <Box sx={{ flex: 1, minHeight: 0, height: "100%", display: "flex", flexDirection: "column", pt: 2 }}>
      <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "280px 1fr", height: "100%" }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default Files;
